import React from "react";
import { motion } from "framer-motion";
import { MANIFESTO } from "@/lib/site";

export const Manifesto = () => {
  return (
    <section
      id="manifesto"
      data-testid="manifesto-section"
      className="surface-canvas py-12 sm:py-16 md:py-24"
    >
      <div className="mx-auto max-w-[1200px] px-4 sm:px-6">
        {/* Centered Section Header */}
        <div className="flex flex-col items-center text-center">
          <motion.h2
            initial={{ opacity: 0, y: 15 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="text-heading max-w-[800px] text-[#222222]"
          >
            Mission &amp; Vision
          </motion.h2>

          <motion.p
            initial={{ opacity: 0, y: 15 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="mt-4 sm:mt-6 text-body-editorial max-w-[640px] text-[#222222]"
          >
            Three foundational principles that govern every product we architect,
            every engineer we mentor, and every client relationship we build.
          </motion.p>
        </div>

        {/* Chapters list — clean editorial lines with hairline borders */}
        <div className="mt-10 sm:mt-14 max-w-[880px] mx-auto divide-y divide-[#ebebeb] border-y border-[#ebebeb]">
          {MANIFESTO.map((m, i) => (
            <motion.div
              key={m.number}
              initial={{ opacity: 0, y: 15 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              data-testid={`manifesto-item-${m.number}`}
              className="py-6 sm:py-8 md:py-10 grid grid-cols-1 sm:grid-cols-12 gap-3 sm:gap-6 items-start"
            >
              <div className="sm:col-span-2">
                <span className="text-[17px] sm:text-[20px] font-medium text-[#6a6a6a]">
                  {m.number}
                </span>
              </div>
              <div className="sm:col-span-10">
                <h3 className="text-subheading text-[#222222]">
                  {m.title}
                </h3>
                <p className="mt-2 sm:mt-3 text-body-editorial text-[#222222]">
                  {m.body}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
